{
  "SERVICES_LIST_PAGE": "Select service",
  "SERVICES_CONFIRMATION_PAGE": "Order",
  "SERVICES_THANK_YOU_PAGE": "Complete!"
}
